import "./RemoveCompletedTasks.scss";
import { useTranslation } from "react-i18next";

function RemoveCompletedTasks({
  cancelRemoveCompletedTasks,
  removeCompletedTasks,
}) {
  const { t } = useTranslation();
  return (
    <div className="remove-completed-tasks-content">
      <div className="modal-title">
        <div>{t("tasks.modals.removeCompletedTasks.title")}</div>
      </div>
      <div className="modal-body">
        <p>{t("tasks.modals.removeCompletedTasks.message")}</p>
        <p>
          <strong>{t("tasks.modals.removeCompletedTasks.cannotUndo")}</strong>
        </p>
      </div>
      <div className="modal-form-buttons">
        <button
          className="modal-button cancel"
          onClick={cancelRemoveCompletedTasks}
        >
          {t("common.cancel")}
        </button>
        <button className="modal-button save" onClick={removeCompletedTasks}>
          {t("common.delete")}
        </button>
      </div>
    </div>
  );
}

export default RemoveCompletedTasks;
